import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthGuard } from './_guards/auth.guard';
import { JwtInterceptor } from './_helper/jwt.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthenticationService } from './_services/authentication.service';

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [
        CommonModule,
    ],
})
export class CoreModule {
    static forRoot(): ModuleWithProviders<any> {
        return {
            ngModule: CoreModule,
            providers: [
                AuthGuard,
                AuthenticationService,
                { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }
            ]
        };
    }
}
